import { render } from "./NotificationsPage.vue?vue&type=template&id=20edf73e&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"

import "./NotificationsPage.vue?vue&type=style&index=0&id=20edf73e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20edf73e"]])

export default __exports__